import { ChapterNode } from '../types-v6'
import { Tree } from '@fluentui/react-components'
import { MouseEvent } from 'react'
import { TreeNode } from './TreeNode'

interface IndexSelectorProps {
  indexData: ChapterNode[]
  selectedContentIds: string[]
  handleContentSelection: (contentIds: string[]) => void
  handleUnselectContent: (contentIds: string[]) => void
}

export function IndexSelectorV2({
  indexData,
  selectedContentIds,
  handleContentSelection,
  handleUnselectContent,
}: IndexSelectorProps) {
  /**
   * Handles checkbox change events from any level of the tree.
   * Aggregates content references and calls the appropriate handler.
   *
   * @param contentIds - Array of content reference IDs to select/deselect
   * @param checked - Whether the checkbox was checked (true) or unchecked (false)
   * @param e - Optional mouse event if called directly from a click event
   */
  const handleCheckChange = (contentIds: string[], checked: boolean, e?: MouseEvent) => {
    // Prevent the event from bubbling up to the TreeItem if event exists
    if (e) {
      e.stopPropagation()
    }

    // Only proceed if there are content IDs to process
    if (contentIds.length === 0) return

    // Call the appropriate handler based on checkbox state
    if (checked) {
      handleContentSelection(contentIds)
    } else {
      handleUnselectContent(contentIds)
    }
  }

  /**
   * Prevents click events on checkboxes from triggering tree item expansion/collapse
   */
  const handleCheckboxClick = (e: MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <div className="relative max-w-96">
      <Tree aria-label="Index Hierarchy">
        {indexData.map((chapter) => (
          <TreeNode
            key={chapter.id}
            node={chapter}
            selectedItems={selectedContentIds}
            onCheckChange={handleCheckChange}
            onCheckboxClick={handleCheckboxClick}
            level={1}
          />
        ))}
      </Tree>
    </div>
  )
}
